module.exports = __webpack_public_path__ + "static/media/payingFees.878868e9.webp";